import { useEffect, useState } from "react";
import { Phone, Wrench } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const Header = () => {
  const { t, lang, toggle } = useI18n();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A0A0C]/85 border-b border-zinc-800"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="logo-button"
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 bg-[#E51E1A] flex items-center justify-center group-hover:rotate-12 transition-transform">
            <Wrench className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-headings uppercase text-white text-xl md:text-2xl leading-none tracking-wide">
            Torque Latino
            <span className="block text-[10px] tracking-[0.4em] text-[#E51E1A] mt-0.5">
              MOBILE · RI
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8 font-condensed uppercase text-sm tracking-widest text-zinc-300">
          <button data-testid="nav-services" onClick={() => scrollTo("services")} className="hover:text-[#E51E1A] transition">
            {t.nav.services}
          </button>
          <button data-testid="nav-gallery" onClick={() => scrollTo("gallery")} className="hover:text-[#E51E1A] transition">
            {t.nav.gallery}
          </button>
          <button data-testid="nav-booking" onClick={() => scrollTo("booking")} className="hover:text-[#E51E1A] transition">
            {t.nav.booking}
          </button>
          <button data-testid="nav-contact" onClick={() => scrollTo("contact")} className="hover:text-[#E51E1A] transition">
            {t.nav.contact}
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            data-testid="lang-toggle"
            className="border border-zinc-700 hover:border-[#E51E1A] hover:text-[#E51E1A] transition px-3 py-2 font-headings uppercase text-sm tracking-wider text-white"
          >
            {lang === "es" ? "EN" : "ES"}
          </button>
          <a
            href="tel:+14175140081"
            data-testid="header-call-cta"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E51E1A] hover:bg-[#FF3B30] text-white font-headings uppercase text-sm tracking-wider px-4 py-2 transition-all hover:-translate-y-0.5"
          >
            <Phone className="w-4 h-4" />
            {t.nav.callNow}
          </a>
        </div>
      </div>
    </header>
  );
};
